"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SupportBanner = SupportBanner;
exports.SupportText = exports.SupportNumber = exports.SupportContent = exports.SupportBannerContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const SupportBannerContainer = exports.SupportBannerContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SupportBannerContainer",
  class: "pl-s1p5q0lt"
});
const SupportContent = exports.SupportContent = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "SupportContent",
  class: "pl-s1f7bnsf"
});
const SupportText = exports.SupportText = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "SupportText",
  class: "pl-s1elgtp6"
});
const SupportNumber = exports.SupportNumber = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "SupportNumber",
  class: "pl-sfcpcfb"
});

/**
 * Footer Menu component.
 *
 * @param {Object} props React props
 * @param {node} props.supportText Text string
 * @param {node} props.supportNumber Text string
 * @returns {React.ReactElement} Footer Legal layout
 * @public
 */
function SupportBanner({
  id,
  supportText,
  supportNumber
}) {
  return /*#__PURE__*/_react.default.createElement(SupportBannerContainer, {
    id: `id-${id}`,
    "data-cy": "support-banner"
  }, /*#__PURE__*/_react.default.createElement(SupportContent, null, /*#__PURE__*/_react.default.createElement(SupportText, null, supportText, " ", /*#__PURE__*/_react.default.createElement(SupportNumber, null, supportNumber))));
}
SupportBanner.propTypes = {
  id: _propTypes.default.string,
  supportText: _propTypes.default.string,
  supportNumber: _propTypes.default.string
};